import React, { useState } from 'react'
import { Avatar, Button, Paper, Grid, Typography, Container } from '@material-ui/core';
import Icon from './Icon';
import useStyles from './styles';
import LockOutlineIcon from '@material-ui/icons/LockOutlined';
import Input from './Input';
import { useDispatch } from 'react-redux';
import { GoogleLogin } from 'react-google-login';
import { LoginActionType } from '../../constants/actionTypes';
import { useHistory } from 'react-router-dom';
import { signin, signup } from '../../actions/auth';

const initialState = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
};

function Auth() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [isSignUp, setSignUp] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState(initialState);


    const handleSubmit = (event) => {
        event.preventDefault();

        if(isSignUp) {
            dispatch(signup(formData, history));
        } else {
            dispatch(signin(formData, history));
        }

    };

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    }

    const switchMode = () => {
        setSignUp((prevState) => !isSignUp);
        handleShowPassword(false);
    }

    const googleSuccess = (res) => {
        const result = res?.profileObj;
        const token = res?.tokenId;

        try {
            dispatch({ type: LoginActionType.AUTH, data: { result, token }});
            history.push('/'); 
        } catch (error) {
            console.log(error);
        }
    }

    const googleFailure = (error) => {
        console.log("Google Sign In was unsuccessful. Please try again.");
        console.log(error);
    }

    const handleShowPassword = () => {
        setShowPassword((prevState) => !prevState);
    }

  return (
    <Container component="main" maxWidth="xs">
        <Paper className={classes.paper} elevation={3}>
            <Avatar className={classes.avatar}>
                <LockOutlineIcon />
            </Avatar>
            <Typography variant='h5' >
                {isSignUp ? 'Sign Up' : 'Sign In'}
            </Typography>
            <form className={classes.form} onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    {
                        isSignUp && (
                            <>
                                <Input name="firstName" label="First Name" handleChange={handleChange} autoFocus half />
                                <Input name="lastName" label="Last Name" handleChange={handleChange} half />
                            </>
                        )
                    }
                    
                    <Input name='email' label="Email Address" handleChange={handleChange} type="email" />
                    <Input
                        name='password'
                        label="Password"
                        handleChange={handleChange}
                        type={showPassword ? "text" : "password"}
                        handleShowPassword={handleShowPassword}    
                    />
                    { isSignUp && <Input name="confirmPassword" label="Confirm Password" handleChange={handleChange} type="password"/>}
                </Grid>
                <Button type='submit' fullWidth variant='contained' color='primary' className={classes.submit}>
                    {isSignUp ? "Sign Up" : "Sign In"}
                </Button>
                <GoogleLogin
                    clientId="541395525472-7b0v6k9n4snbad43phvt6eim6a7q7i64.apps.googleusercontent.com"
                    render={renderProps => (
                        <Button
                            className={classes.googleButton}
                            color="primary"
                            fullWidth
                            onClick={renderProps.onClick}
                            disabled={renderProps.disabled}
                            startIcon={<Icon />}
                            variant="contained"
                        >
                            Google Sign In
                        </Button>
                    )}
                    onSuccess={googleSuccess}
                    onFailure={googleFailure}
                    cookiePolicy={'single_host_origin'}
                />
                <Grid container justifyContent='flex-end'>
                    <Grid item>
                        <Button onClick={switchMode} color="secondary" >
                            {isSignUp ? "Already have an account? Sign In" : "Don't have an account? Sign Up"}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Paper>
    </Container>
  )
}

export default Auth;
